import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../../../middleware/dataSlice';
import { ApiResponse } from '../../../../models/ApiResponseDto';

export const downloadFilePage = createApi({
    reducerPath: 'downloadFilePage',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getFiles: builder.mutation<ApiResponse, { path: string }>({
            query: ({ path }) => ({
                url: `/api/Card/getFiles?path=${path}`,
                method: 'GET',
            }),
        }),
        downloadFile: builder.mutation<Blob, { path: string, fileName: string }>({
            query: ({ path, fileName }) => ({
                url: `/api/Card/DownloadFile?path=${path}/&fileName=${fileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
        }),
    }),
});

export const { useGetFilesMutation, useDownloadFileMutation } = downloadFilePage;
